export default class Locale_BulkEditor { 
	SelectPropertiesToEdit: string = "Select properties to edit";
	AllSelectedPropertiesWillBeSetOnTheSelectedItems: string = "All selected properties will be set on the selected items.";
}